import { Dispatch, SetStateAction } from 'react';
import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ConfirmModal from '../../../../../components/confirm-modal/ConfirmModal';
import { secondaryBlue, secondaryPink } from '../../../../../utils/color';
import { ReactComponent as ErrorAlertIcon } from '../../../../../assets/icons/layout-icons/ErrorAlertIcon.svg';
import { ReactComponent as RequestReviewIcon } from '../../../../../assets/icons/project-icons/RequestReviewIcon.svg';
import { ReactComponent as SaveIcon } from '../../../../../assets/icons/layout-icons/SaveIcon.svg';
import { ReactComponent as CancelIcon } from '../../../../../assets/icons/project-icons/CancelCircleIcon.svg';

const modalsContent = {
  create: {
    title: 'caseStudies.modals.create.title',
    text: 'caseStudies.modals.create.text',
    icon: <RequestReviewIcon fill={secondaryBlue[700]} style={{ width: 24, height: 24 }} />,
    wrapperBackgroundColor: secondaryBlue[100],
  },
  edit: {
    title: 'caseStudies.modals.edit.title',
    text: 'caseStudies.modals.edit.text',
    icon: <RequestReviewIcon fill={secondaryBlue[700]} style={{ width: 24, height: 24 }} />,
    wrapperBackgroundColor: secondaryBlue[100],
  },
  draft: {
    title: 'caseStudies.modals.draft.title',
    text: 'caseStudies.modals.draft.text',
    icon: <SaveIcon fill={secondaryBlue[700]} style={{ width: 24, height: 24 }} />,
    wrapperBackgroundColor: secondaryBlue[100],
  },
  error: {
    title: 'caseStudies.modals.error.title',
    text: 'caseStudies.modals.error.text',
    icon: <ErrorAlertIcon fill={secondaryPink[700]} style={{ width: 24, height: 24 }} />,
    wrapperBackgroundColor: secondaryPink[100],
  },
  cancel: {
    title: 'caseStudies.modals.cancel.title',
    text: 'caseStudies.modals.cancel.text',
    icon: <CancelIcon fill={secondaryBlue[700]} style={{ width: 24, height: 24 }} />,
    wrapperBackgroundColor: secondaryBlue[100],
  },
};

type CaseStudiesCreateModalProps = {
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  isOpen: boolean;
  type: 'create' | 'edit' | 'error' | 'draft' | 'cancel';
  errorMessage?: string;
  onConfirm?: () => void;
};

const CaseStudiesCreateModal = ({
  isOpen,
  setIsOpen,
  type,
  errorMessage,
  onConfirm,
}: CaseStudiesCreateModalProps) => {
  const { t } = useTranslation();
  const message = errorMessage || t(modalsContent[type].text);
  const navigate = useNavigate();
  const confirm = onConfirm || (() => navigate('../'));

  return (
    <ConfirmModal
      isModalOpen={isOpen}
      setIsModalOpen={setIsOpen}
      title={t(modalsContent[type].title)}
      message={
        <Typography color="primaryDark.500" lineHeight="21px">
          {message}
        </Typography>
      }
      confirmButtonText={
        type === 'draft'
          ? t('common.confirm')
          : type === 'cancel'
          ? t('common.proceed')
          : t('common.close')
      }
      onConfirm={confirm}
      iconProps={{
        icon: modalsContent[type].icon,
        wrapperBackgroundColor: modalsContent[type].wrapperBackgroundColor,
      }}
      showCancelButton={type === 'draft' || type === 'cancel'}
      onCancel={() => setIsOpen(false)}
    />
  );
};

export default CaseStudiesCreateModal;
